import { ApiService } from './api.service';
import { Observable } from 'rxjs/Rx';
import { Injectable } from '@angular/core';

@Injectable()
export class DashboardService {

  constructor(private apiService: ApiService) {

  }

  /**
   * Fetch all data for dashboard page<br>
   * It's called once
   */
  recent(): Observable<any> {
    return this.apiService.get('gandadmin/dashboard/recent');
  }

  statistics(): Observable<any> {
    return this.apiService.get('gandadmin/dashboard/statistics');
  }

  timeline(offset = 0, limit = 10): Observable<any> {
    return this.apiService.get('gandadmin/dashboard/timeline?offset=' + offset + '&limit=' + limit);
  }

  today(): Observable<any> {
    return this.apiService.get('gandadmin/dashboard/today');
  }
}
